const SESSION_KEY = "rogo_show_test_jobs";

/**
 * The admin account-menu "Show Test Jobs" switch. While it is on, `StandardAxiosConfig` sends
 * `X-Show-Test-Jobs`, and the API stops hiding test jobs from the ops reads that hide them from
 * everyone by default (the issues queues and the unscheduled backlog). The API honors the header
 * for rogo admins only, so a stale value under another login changes nothing.
 *
 * Backed by `sessionStorage`, like impersonation: it survives a reload but not a tab close, so
 * test jobs can't linger in someone's scheduling backlog because they forgot the switch was on.
 */
export const showTestJobsStore = {
	get: (): boolean => sessionStorage.getItem(SESSION_KEY) === "true",
	set(show: boolean): void {
		if (show) sessionStorage.setItem(SESSION_KEY, "true");
		else sessionStorage.removeItem(SESSION_KEY);
	},
};
